goog.provide("shadow.js.shim.module$date_fns$locale$ca$default");
shadow.js.shim.module$date_fns$locale$ca$default = esm_import$date_fns$locale$ca.default;
